import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "logo_area" }
const _hoisted_2 = ["src"]

import { useRouter } from "vue-router";
import logo from "@/assets/img/logo.svg";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const isMobileMenuOpen = ref(false);
const route = useRouter();

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};
const closeMobileMenu = () => {
  isMobileMenuOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass({ isMobileMenuOpen: isMobileMenuOpen.value })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _unref(logo),
            alt: "Logo",
            height: "40"
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["hamburger_menu", { 'is-active': isMobileMenuOpen.value }]),
      onClick: toggleMobileMenu
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "bar" }, null, -1),
      _createElementVNode("span", { class: "bar" }, null, -1),
      _createElementVNode("span", { class: "bar" }, null, -1)
    ]), 2),
    _createElementVNode("nav", {
      class: _normalizeClass(["site_nav", { 'is-open': isMobileMenuOpen.value }])
    }, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: _normalizeClass({ active: _unref(route).currentRoute.value.path === '/' })
        }, [
          _createVNode(_component_router_link, {
            to: "/",
            onClick: closeMobileMenu
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("トップページ")
            ])),
            _: 1,
            __: [1]
          })
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass({ active: _unref(route).currentRoute.value.path === '/philosophy' })
        }, [
          _createVNode(_component_router_link, {
            to: "/philosophy",
            onClick: closeMobileMenu
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("私たちの思い")
            ])),
            _: 1,
            __: [2]
          })
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass({ active: _unref(route).currentRoute.value.path === '/feature' })
        }, [
          _createVNode(_component_router_link, {
            to: "/feature",
            onClick: closeMobileMenu
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("私たちの強み")
            ])),
            _: 1,
            __: [3]
          })
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass({ active: _unref(route).currentRoute.value.path === '/result' })
        }, [
          _createVNode(_component_router_link, {
            to: "/result",
            onClick: closeMobileMenu
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("お客様の声")
            ])),
            _: 1,
            __: [4]
          })
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass({ active: _unref(route).currentRoute.value.path === '/contact' })
        }, [
          _createVNode(_component_router_link, {
            to: "/contact",
            onClick: closeMobileMenu
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("お問い合わせ")
            ])),
            _: 1,
            __: [5]
          })
        ], 2)
      ])
    ], 2)
  ], 2))
}
}

})